import { useNavigate } from 'react-router-dom';
import { of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { UserBlockDetails } from '../../../core/interfaces/trial-details';
import { TrialDetailsService } from '../../../core/services/trial-details.service';
import useService from '../../../injector/hooks/useService';

export function useTrialExpiryGuard() {
  const trialDetailsService = useService(TrialDetailsService);
  const navigate = useNavigate();

  const executeTrialExpiryGuard = () => {
    return trialDetailsService.shouldBlockUser$.pipe(
      take(1),
      map((userBlockDetails: UserBlockDetails) => {
        if (userBlockDetails.blockUser) {
          navigate(userBlockDetails.redirectRoute);
        }

        return !userBlockDetails.blockUser;
      }),
      catchError((error) => {
        return of(true);
      })
    ).toPromise();
  };

  return {
    executeTrialExpiryGuard
  }
}
